<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/rheinhessen')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/rheinhessen/klaus-peter-keller')">Klaus-Peter Keller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/rheinhessen/von-buhl')">Von Buhl
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/rheinhessen')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Von Buhl</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        In un giorno in cui tutto è documentato; il pasto di tua sorella è su Instagram, seleziona Google
                        pubblicità basate sulla tua cronologia di navigazione e persino il gatto di Karl Lagerfeld è considerato “un
                        influencer”, è una sorpresa molto gradita trovare un eroe sconosciuto. Fare tranquillamente qualità
                        Vini Riesling da oltre 150 anni nella loro nativa Deidesheim, senza fronzoli Reichsrat von Buhl è un
                        Respiro d'aria fresca.
                    </div>

                    <div class="howto-title2">Non c'è von Buhl qui</div>
                    <div class="howto-text">
                        Il vigneto di proprietà della famiglia fu fondato nel 1849 e il vino ebbe un notevole successo in
                        la fine del XIX secolo; compositore Felix Mendelssohn era un fan, è stato servito ai dignitari del
                        apertura del canale di Suez (diventando così uno dei vini più costosi al mondo) ed esso
                        era il Riesling preferito del cancelliere tedesco Otto von Bismarck. Tuttavia, cattiva gestione, due
                        le guerre mondiali e le difficoltà economiche fecero sì che la tenuta iniziò a fallire e i 200 ettari lo furono
                        ridimensionato a soli 52. Inserisci il donchisciottesco Adim Niederberger che ha acquistato la tenuta nel suo
                        interamente nel 2013. Purtroppo Niederberger morì lo stesso anno, ma le radici del cambiamento avevano
                        già iniziato; e l'intramontabile Riesling era sulla buona strada per essere ancora una volta un sostenitore
                        vini.
                        <br><br>
                        Gran parte del successo dell'era moderna di cui Von Buhl ha goduto potrebbe essere attribuito a due uomini: la gestione
                        il regista Richard Grosche e il direttore tecnico Mathieu Kauffmann. Insieme si sono risvegliati
                        questo gigante addormentato. Hanno aggiunto il tocco moderno; sono certificati biologici, hanno
                        rese drasticamente ridotte e coltivare in modo biodinamico.
                    </div>

                    <div class="howto-title2">12 anni alla Bollinger</div>
                    <div class="howto-text">
                        Per dirla semplicemente, il nuovo team Grosche/Kauffmann lo sta inchiodando. Kauffmann ha portato i suoi 12
                        anni di esperienza in Bollinger a Von Buhl e ha lanciato i vini a un livello completamente nuovo. Von
                        I nove bianchi e un rosso di Buhl offrono una portata sbalorditiva: a partire da soli € 5 a bottiglia per il
                        lussureggiante 2017 Reichsrat von Buhl Riesling Halbtrocken a € 1.549 (aprile 2019) 1893 Reichsrat von
                        Buhl Deidesheimer Muhl & Geheu Riesling. Praticamente imbevibile, quest'ultimo vino conserva
                        interesse degli investitori anno dopo anno.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Reichsrat von Buhl è uno dei pochi produttori che stanno aprendo la strada all'attuale tendenza di
                                detenere Grosses Gewachs Rieslings un anno in più (o più) prima del rilascio garantendo
                                vini meglio integrati. Guardando il Forster Pechstein Riesling Grosses di von Buhl
                                Gewachs, i prezzi per l'annata 2016 sono rimasti stabili sia prima che dopo il rilascio, e oltre
                                i prezzi complessivi per tutte le annate disponibili sono aumentati di oltre il 30% nelle due
                                periodo annuale da giugno 2017.
                            </li>
                            <li>Il 2018 segna la prima annata completamente biodinamica di Reichsrat von Buhl.</li>
                            <li>In uscita a settembre 2019, quattro dei vini di Van Buhl sono già entrati nella "Top Ten" di Vinous/David Schilknecht nel rapporto sull'annata Pfalz 2017 pubblicato nel primo trimestre del 2019. Ciò include Kirchenstuck che detiene la posizione numero uno con un punteggio di 96 Prima del rilascio, i prezzi erano in media di € 95 a bottiglia nel secondo trimestre del 2019. Nello stesso rapporto, Pechstein ha ricevuto 95 punti (mentre comandava in media € 40 a bottiglia) e sia Ungeheuer che Reiterpfad Hofstuck hanno ricevuto 94 punti.</li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Von Buhl</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        An einem Tag, an dem alles dokumentiert ist; Das Essen deiner Schwester ist auf Instagram, wählt Google aus
                        Werbung basierend auf Ihrem Browserverlauf und sogar Karl Lagerfelds Katze gilt als „an
                        „Influencer“ ist es eine willkommene Überraschung, einen unbesungenen Helden zu finden. Leise Qualität herstellen
                        Rieslingweine seit über 150 Jahren in ihrer Heimat Deidesheim, ohne viel Aufhebens ist Reichsrat von Buhl ein
                        Hauch frischer Luft.
                    </div>

                    <div class="howto-title2">Kein von Buhl hier</div>
                    <div class="howto-text">
                        Der familieneigene Weinberg wurde 1849 gegründet und der Wein erfreute sich im Jahr 1849 großer Erfolge
                        das späte 19. Jahrhundert; Komponist Felix Mendelssohn war ein Fan, es wurde an Würdenträger serviert
                        Eröffnung des Suezkanals (und damit einer der teuersten Weine der Welt) und es
                        war der Lieblingsriesling des deutschen Bundeskanzlers Otto von Bismarck. Allerdings schlechtes Management, zwei
                        Weltkriege und wirtschaftliche Schwierigkeiten führten dazu, dass das Anwesen zu versagen begann und die 200 Hektar Land zerstört wurden
                        auf nur 52 reduziert. Da kommt der weltfremde Adim Niederberger ins Spiel, der das Anwesen in seinem Besitz erworben hat
                        komplett im Jahr 2013. Leider verstarb Niederberger im selben Jahr, aber die grundlegenden Veränderungen hatten stattgefunden
                        schon begonnen; und der zeitlose Riesling war auf dem Weg, erneut eine feste Größe unter ihnen zu sein
                        Weine.
                        <br><br>
                        Ein großer Teil des modernen Erfolgs, den Von Buhl genießt, lässt sich auf zwei Männer zurückführen: das Management
                        Direktor Richard Grosche und technischer Direktor Mathieu Kauffmann. Gemeinsam sind sie erwacht
                        dieser schlafende Riese. Sie haben den modernen Touch hinzugefügt; Sie sind aus kontrolliert biologischem Anbau
                        drastisch reduzierte Erträge und biologisch-dynamische Landwirtschaft.
                    </div>

                    <div class="howto-title2">12 Jahre bei Bollinger</div>
                    <div class="howto-text">
                        Um es einfach auszudrücken: Das neue Grosche/Kauffmann-Team hat es geschafft. Kauffmann hat seine 12 mitgebracht
                        Jahrelange Erfahrung bei Bollinger an Von Buhl weitergegeben und die Weine auf ein ganz neues Niveau gebracht. Von
                        Die neun Weißweine und ein Rotwein von Buhl bieten eine atemberaubende Auswahl: schon ab 5 € pro Flasche
                        üppiger 2017 Reichsrat von Buhl Riesling Halbtrocken zu 1.549 € (April 2019) 1893 Reichsrat von
                        Buhl Deidesheimer Muhl & Geheu Riesling. Dieser letztere Wein ist praktisch ungenießbar und behält seinen Geschmack
                        Jahr für Jahr das Interesse der Anleger.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Reichsrat von Buhl ist einer der wenigen Produzenten, die den aktuellen Trend vorantreiben
                                Halten Sie Grosses Gewächs-Rieslinge ein weiteres Jahr (oder länger) vor der Veröffentlichung sicher
                                besser integrierte Weine. Blick auf von Buhls Forster Pechstein Riesling Grosses
                                Wachsen blieben die Preise für den Jahrgang 2016 sowohl vor als auch nach der Veröffentlichung und darüber hinaus stabil
                                Die Gesamtpreise für alle verfügbaren Jahrgänge sind in beiden Fällen um mehr als 30 % gestiegen
                                Jahreszeitraum ab Juni 2017.
                            </li>
                            <li>2018 markiert Reichsrat von Buhls ersten vollständig biodynamischen Jahrgang.</li>
                            <li>Vier von Van Buhls Weinen, die im September 2019 erscheinen sollen, haben es bereits in die „Top Ten“ von Vinous/David Schilknecht im Jahrgangsbericht 2017 der Pfalz geschafft, der im ersten Quartal 2019 veröffentlicht wurde. Dazu gehört auch Kirchenstuck, der mit einer Bewertung von 96 den ersten Platz belegt . Vor der Markteinführung lagen die Preise im 2. Quartal 2019 bei durchschnittlich 95 € pro Flasche. Im selben Bericht erhielt Pechstein 95 Punkte (bei durchschnittlich 40 € pro Flasche) und sowohl Ungeheuer als auch Reiterpfad Hofstuck erhielten 94 Punkte.</li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Von Buhl</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        À une époque où tout est documenté; le repas de ta sœur est sur instagram, Google sélectionne
                        des publicités basées sur votre historique de navigation et même le chat de Karl Lagerfeld est considéré comme « un
                        influenceur », c'est une très bonne surprise de trouver un héros méconnu. Faire tranquillement de la qualité
                        Vins de Riesling depuis plus de 150 ans dans leur Deidesheim natal, pas de chichi Reichsrat von Buhl est un
                        bouffée d'air frais.
                    </div>

                    <div class="howto-title2">Pas de von Buhl ici</div>
                    <div class="howto-text">
                        Le vignoble familial a été créé en 1849 et le vin a connu un succès considérable dans
                        la fin du 19e siècle; compositeur Felix Mendelssohn était un fan, il a été servi aux dignitaires à la
                        l'ouverture du canal de Suez (devenant ainsi l'un des vins les plus chers au monde) et il
                        était le riesling préféré du chancelier allemand Otto von Bismarck. Cependant, une mauvaise gestion, deux
                        les guerres mondiales et les difficultés économiques ont fait que le domaine a commencé à échouer et les 200 hectares ont été
                        réduit à seulement 52. Entrez le chimérique Adim Niederberger qui a acheté le domaine dans sa
                        intégralité en 2013. Malheureusement, Niederberger est décédé la même année, mais les racines du changement avaient
                        déjà commencé; et l'intemporel Riesling était en passe de redevenir un pilier parmi les
                        vins.
                        <br><br>
                        Une grande partie du succès de l'ère moderne dont a joui Von Buhl pourrait être attribuée à deux hommes : gérer
                        réalisateur Richard Grosche et directeur technique Mathieu Kauffmann. Ensemble, ils se sont réveillés
                        ce géant endormi. Ils ont ajouté la touche moderne ; ils sont certifiés biologiques, ont
                        rendements considérablement réduits et cultiver en biodynamie.
                    </div>

                    <div class="howto-title2">12 ans chez Bollinger</div>
                    <div class="howto-text">
                        Pour faire simple, la nouvelle équipe Grosche/Kauffmann est en train de le clouer. Kauffmann a apporté ses 12
                        années d'expérience chez Bollinger à Von Buhl et a lancé les vins à un tout autre niveau. Par
                        Les neuf blancs et un rouge de Buhl offrent un éventail époustouflant : à partir de 5 € la bouteille pour le
                        2017 luxuriant Reichsrat von Buhl Riesling Halbtrocken à 1 549 € (avril 2019) 1893 Reichsrat von
                        Buhl Deidesheimer Muhl & Geheu Riesling. Pratiquement imbuvable, ce dernier vin conserve
                        l'intérêt des investisseurs année après année.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Reichsrat von Buhl fait partie d'une poignée de producteurs pionniers de la tendance actuelle de
                                détenir des Grosses Gewachs Rieslings une année supplémentaire (ou plus) avant la sortie en veillant à
                                vins mieux intégrés. En regardant le Forster Pechstein Riesling Grosses de von Buhl
                                Gewachs, les prix du millésime 2016 sont restés stables avant et après la sortie, et sur
                                l'ensemble des prix de tous les millésimes disponibles a augmenté de plus de 30% dans les deux
                                période de l'année à partir de juin 2017.
                            </li>
                            <li>2018 marque le premier millésime entièrement biodynamique de Reichsrat von Buhl.</li>
                            <li>A paraître en septembre 2019, quatre des vins de Van Buhl ont déjà atteint le "Top Ten" de Vinous/David Schilknecht dans le rapport sur le millésime Pfalz 2017 publié au premier trimestre 2019. Parmi eux, Kirchenstuck occupe la première place avec un score de 96 Avant la sortie, les prix étaient en moyenne de 95 € par bouteille au deuxième trimestre 2019. Dans le même rapport, Pechstein a reçu 95 points (tout en commandant en moyenne 40 € par bouteille) et Ungeheuer et Reiterpfad Hofstuck ont reçu 94 points.</li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Von Buhl</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        In a day when everything is documented; your sister’s meal is on instagram, Google selects
                        advertisements based on your browsing history and even Karl Lagerfeld’s cat is considered “an
                        influencer”, it comes as a very welcome surprise to find an unsung hero. Quietly making quality
                        Riesling wines for over 150 years in their native Deidesheim, no fuss Reichsrat von Buhl is a
                        breath of fresh air.
                    </div>

                    <div class="howto-title2">No von Buhl here</div>
                    <div class="howto-text">
                        The family owned vineyard was established in 1849, and the wine enjoyed considerable success in
                        the late 19th century; composer Felix Mendelssohn was a fan, it was served to dignitaries at the
                        opening of the Suez canal (thus becoming one of the most expensive wines in the world) and it
                        was German Chancellor Otto von Bismarck’s favourite Riesling. However, poor management, two
                        world wars and economic difficulties meant the estate began failing and the 200-hectares were
                        scaled back to just 52. Enter the quixotic Adim Niederberger who purchased the estate in its
                        entirety in 2013. Sadly Niederberger died the same year, but the grass roots of change had
                        already begun; and the timeless Riesling was on its way to once again being a stalwart among
                        wines.
                        <br><br>
                        Much of the modern-era success that Von Buhl has enjoyed could be put down to two men: managing
                        director Richard Grosche and technical director Mathieu Kauffmann. Together they have awakened
                        this sleeping giant. They have added the modern touch; they are certified organic, have
                        dramatically reduced yields and farm biodynamically.
                    </div>

                    <div class="howto-title2">12-years at Bollinger</div>
                    <div class="howto-text">
                        To put it simply, the new Grosche/Kauffmann team are nailing it. Kauffmann has brought his 12
                        years of experience at Bollinger to Von Buhl and launched the wines to a whole new level. Von
                        Buhl’s nine whites and one red offer a staggering scope: from as little as €5 a bottle for the
                        lush 2017 Reichsrat von Buhl Riesling Halbtrocken to the €1,549 (April 2019) 1893 Reichsrat von
                        Buhl Deidesheimer Muhl & Geheu Riesling. Virtually undrinkable, this latter wine retains
                        investor interest year after year.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Reichsrat von Buhl is one of a handful of producers pioneering the current trend of
                                holding Grosses Gewachs Rieslings an additional year (or more) prior to release ensuring
                                better integrated wines. Looking at von Buhl's Forster Pechstein Riesling Grosses
                                Gewachs, prices for the 2016 vintage held steady both prior to and after release, and on
                                the whole prices for all available vintages have increased by more than 30% in the two
                                year period from June 2017.
                            </li>
                            <li>2018 marks Reichsrat von Buhl’s first fully-biodynamic vintage.</li>
                            <li>To be released in September 2019, four of Van Buhl’s wines already made it to Vinous/David Schilknecht’s “Top Ten” in the Pfalz 2017 vintage report released in Q1 2019. This includes Kirchenstuck holding position number one with a score of 96. Prior to release prices averaging €95 per bottle in Q2 2019. In the same report, Pechstein received 95 points (while commanding on average €40 per bottle) and both Ungeheuer and Reiterpfad Hofstuck received 94 points.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VonBuhl",
    data() {
        return {
            select: {report: 'Von Buhl', src: '/wine-guide/germany/rheinhessen/von-buhl'},
            items: [
                {report: 'Klaus-Peter Keller', src: '/wine-guide/germany/rheinhessen/klaus-peter-keller'},
                {report: 'Von Buhl', src: '/wine-guide/germany/rheinhessen/von-buhl'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Von Buhl | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich heritage and exceptional quality of Von Buhl wine producer. Savor the exceptional taste and aroma of the handcrafted wines made from carefully selected grapes grown in Rheinhessen, Germany. Indulge in the ultimate wine experience and taste the difference with Von Buhl.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
